import { cn, PlayIcon } from "@workspace/frontend-ui";

type Props = {
  thumbnailUrl?: string;
  alt: string;
  isSelected: boolean;
  isProvider?: boolean;
};

const HeroPlaylistThumb: FC<Props> = ({
  thumbnailUrl,
  alt,
  isSelected,
  isProvider,
}) => (
  <span
    className={cn(
      "group/thumb relative h-full max-h-13 shrink-0 overflow-hidden rounded-md transition-transform",
      isProvider ? "aspect-auto w-auto max-w-18" : "aspect-11/8",
      isSelected && "scale-[1.04]",
    )}
  >
    <img
      src={thumbnailUrl}
      alt={alt}
      loading="lazy"
      className={cn(
        "size-full",
        isProvider ? "object-contain in-[.dark]:invert" : "object-cover",
      )}
    />
    <span
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 bg-black/40 opacity-0 transition-opacity group-hover/thumb:opacity-100 motion-reduce:transition-none"
    />
    <span
      aria-hidden="true"
      className="pointer-events-none absolute top-1/2 left-1/2 grid -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full bg-white/5 p-2 opacity-0 backdrop-blur-[4px] transition-opacity group-hover/thumb:opacity-100 motion-reduce:transition-none"
    >
      <PlayIcon className="size-5 text-foreground" />
    </span>
  </span>
);

export default HeroPlaylistThumb;
